import { createContext } from 'react'

import { DefaultConfig, PollingConfig } from '../data'

export type ConfigContextType = {
  uiConfig: DefaultConfig
  pollingConfig: PollingConfig
}

const initialValue: ConfigContextType = {
  uiConfig: {} as DefaultConfig,
  pollingConfig: { intervalInSeconds: 60 },
}

export const ConfigContext = createContext<ConfigContextType>(initialValue)
